export const round = (val: number, num: number) => {
  const coef = Math.pow(10, num);
  return Math.round(val * coef) / coef;
};
